import { validateField } from './validate-field';
export const validateForm = async (validationConfig, formData) => {
    const result = {
        isValid: true,
        validationErrors: {}
    };
    for (const key of Object.keys(validationConfig)) {
        const validationResult = await validateField(validationConfig[key], formData[key]);
        result.validationErrors[key] = validationResult;
        if (!isValidResult(validationResult))
            result.isValid = false;
    }
    return result;
};
const isValidResult = (result) => {
    return result === undefined || (Array.isArray(result) && result.length === 0);
};
//# sourceMappingURL=validate-form.js.map